import { createReducer } from '@reduxjs/toolkit'
import { LineMeasurement } from '../models/Measurement'
import {
  addLineMeasurement,
  removeLineMeasurement,
  updateLineMeasurement,
} from '../actions/measurement'
import { v4 as uuidv4 } from 'uuid'

interface MeasurementState {
  lineMeasurements: Record<string, LineMeasurement>
}

const initialState: MeasurementState = {
  lineMeasurements: {},
}

const measurementReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(addLineMeasurement, (state, action) => {
      const { id, startPoint, endPoint, isVisible } = action.payload
      const x = endPoint.x - startPoint.x
      const y = endPoint.y - startPoint.y
      const z = endPoint.z - startPoint.z
      const newMeasurement: LineMeasurement = {
        id: id ?? uuidv4(),
        startPoint: {
          ...startPoint,
        },
        endPoint: {
          ...endPoint,
        },
        length: Math.sqrt(x * x + y * y + z * z),
        isVisible: isVisible ?? true,
      }
      state.lineMeasurements[newMeasurement.id] = newMeasurement
    })
    .addCase(updateLineMeasurement, (state, action) => {
      const { id, data } = action.payload
      const measurement = state.lineMeasurements[id]
      if (measurement) {
        const startPoint = data.startPoint ?? measurement.startPoint
        const endPoint = data.endPoint ?? measurement.endPoint
        const isVisible = data.isVisible ?? measurement.isVisible

        measurement.startPoint = { ...startPoint }
        measurement.endPoint = { ...endPoint }
        measurement.isVisible = isVisible

        const x = endPoint.x - startPoint.x
        const y = endPoint.y - startPoint.y
        const z = endPoint.z - startPoint.z
        measurement.length = Math.sqrt(x * x + y * y + z * z)
      }
    })
    .addCase(removeLineMeasurement, (state, action) => {
      const { id } = action.payload
      const { [id]: _, ...updatedMeasurements } = state.lineMeasurements
      state.lineMeasurements = updatedMeasurements
    })
})

export default measurementReducer
